(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unmute-media')) {
  class UnmuteMedia extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const section = this.closest('.video-section');
        if (!section) return;

        section.classList.add('video-section--watching');

        const vc = section.querySelector('video-component');
        if (vc && typeof vc.enableControls === 'function') {
          vc.enableControls();
        }
      });
    }
  }
  customElements.define('unmute-media', UnmuteMedia);
}

  } catch(e) { console.error(e); }
})();
})();
